<template>
  <div id="stock-in">
    <b-card>
      <b-row>
        <b-col md="6">
          <h3>{{$route.name}}</h3>
          <!-- breadcrumb -->
          <b-breadcrumb>
            <b-breadcrumb-item
              ><router-link to="/dashboard/">Dashboard</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item
              ><router-link to="/inventory/stock-in">Stock In</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
          </b-breadcrumb>
          <!-- end breadcrumb -->
        </b-col>
      </b-row>
      <div v-if="isLoading" style="position: relative;">
        <div class="text-center text-primary my-2 h-100">
          <b-spinner class="align-middle"></b-spinner>
          <strong> Loading...</strong>
        </div>
      </div>
      <div v-else>
      <b-row>
         <b-col md="6">
            <b-row>
              <b-col md="4"><label class="labels">ID Stock In</label></b-col>
              <b-col md="8"><p>{{ model.stockInId !== null ? model.stockInId : '-' }}</p></b-col>
            </b-row>
            <b-row>
              <b-col md="4"><label class="labels">Stock In Date</label></b-col>
              <b-col md="8"><p>{{ model.stockInDate }}</p></b-col>
            </b-row>
            
            <b-row>
              <b-col md="4"><label class="labels">Journal Account</label></b-col>
              <b-col md="8"><p>{{ model.journalAccount }}</p></b-col>
            </b-row>

             <b-row>
              <b-col md="4"><label class="labels">Created By</label></b-col>
              <b-col md="8"><p>{{ model.createdBy.firstName }}</p></b-col>
            </b-row>

            <b-row>
              <b-col md="4"><label class="labels">Created Date</label></b-col>
              <b-col md="8"><p>{{ model.createdAt }}</p></b-col>
            </b-row>

            <b-row>
              <b-col md="4"><label class="labels">updated By</label></b-col>
              <b-col md="8"><p>{{ model.changedBy.firstName }}</p></b-col>
            </b-row>

            <b-row>
              <b-col md="4"><label class="labels">updated Date</label></b-col>
              <b-col md="8"><p>{{ model.updatedAt }}</p></b-col>
            </b-row>
            <b-row>
              <b-col md="4"><label class="labels">Description</label></b-col>
              <b-col md="8"><p>{{ model.stockInNote }}</p></b-col>
            </b-row>
          </b-col>
          <b-col md="6">
             <b-row>
              <b-col md="4"><label class="labels">Stock Area</label></b-col>
              <b-col md="8"><p>{{ model.stockArea  }}</p></b-col>
            </b-row>
            <b-row>
              <b-col md="4"><label class="labels">Stock Area Address</label></b-col>
              <b-col md="8"><p class="text-justify">{{ model.stockAddress }}</p></b-col>
            </b-row>
    
          </b-col>
        </b-row>
        <b-row class="mt-3 mb-3">
          <b-col md="8">
             <b-table striped hover :items="model.items" :fields="fields">
               <template v-slot:cell(itemList)="row" class="break-text">
                <div :id="'name-tooltip-' + row.item.itemList.uuid">{{row.item.itemList.name !== null ? row.item.itemList.name.substring(0, 100) : '-'}}{{row.item.itemList.name !== null && row.item.itemList.name.length >= 206 ? '...' : ''}}</div>
                <b-tooltip v-if="row.item.itemList.name !== null && row.item.itemList.name.length >= 15" :target="'name-tooltip-' + row.item.itemList.uuid" placement="top">
                  {{row.item.itemList.name}}
                </b-tooltip>
              </template>
              <template v-slot:head(minutes)="data">
                <div class="text-center">{{data.label}}</div>
              </template>
               <template v-slot:cell(stockInItemCogs)="row">
                {{ dataAccount.account.currency }}  {{row.item.stockInItemCogs !== null ? formatPrice(row.item.stockInItemCogs) : '-'}}
               </template>
               <template v-slot:cell(stockInItemPrice)="row">
                {{ dataAccount.account.currency }}  {{row.item.stockInItemPrice !== null ? formatPrice(row.item.stockInItemPrice) : '-'}}
               </template>
              <template></template>
             </b-table>

          </b-col>
        </b-row>
        <b-row>
        </b-row>
           <b-button class="mt-3 mb-3" :to="'/inventory/stock-in'" variant="secondary"
              ><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button
            >
            <!-- <b-button
              class="mt-3 mb-5 float-right"
              :to="'/inventory/stock-in/' + $route.params.uuid + '/edit'"
              variant="warning"
              ><font-awesome-icon icon="pencil-alt"></font-awesome-icon> Edit</b-button
            > -->
      </div>
    </b-card>
  </div>
</template>
<script>
export default {
  data(){
    return {
      isLoading: false,
      dataAccount: this.$store.getters['account/accountData'],

      apiUrl:{
        stockIn: window.AppConfig.apiUrl + 'stock-in'
      },
      fields: [
        {
          key: 'itemList',
          label: 'Item Name',
          class: 'break-text'
        },
        {
          key: 'stockInItemQuantity',
          label: 'Quantity'
        },
        {
          key: 'stockInItemPrice',
          label: 'Price/Unit'
        },
        {
          key: 'stockInItemCogs',
          label: 'Cost Of Goods Sold'
        },
        {
          key: 'stockInItemNote',
          label: 'Description'
        }
      ],
      model:{
        stockInId: null,
        stockInDate: null,
        stockInNote: null,
        stockArea: null,
        stockAddress: null,
        areaCode: null,
        journalAccount: null,
        stockInItem: null,
        stockInItemNote: null,
        stockInItemQuantity: null,
        stockInItemPrice: null,
        itemList: null,
        stockIn: null,
        createdBy: {
          branch: null,
          firstName: null,
          lastName: null
        },
        createdAt: null,
        updatedAt: null,
        changedBy:{
          branch: null,
          firstName: null,
          lastName: null
        },
        items: []
      }
    }
  },

  mounted(){
    this.initData()
  },

  methods: {
    initData(){
      if(this.$route.params.uuid !== undefined){
        this.getDetail()
      }
    },

     formatPrice(value) {
      let val = (value / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },

    getDetail(){
      this.isLoading = true
      this.$http.get(this.apiUrl.stockIn + '/' + this.$route.params.uuid).then(response=>{
        this.model.stockInId = response.data.stockInId !== null ? response.data.stockInId : '-'
        this.model.stockInDate = response.data.stockInDate !== null
              ? this.$moment(response.data.stockInDate  ).format('DD MMMM YYYY')
              : null;
        this.model.stockInNote = response.data.stockInNote !== null ? response.data.stockInNote : '-'
        this.model.stockArea = response.data.stockArea !== null ? response.data.stockArea.areaName : '-'
        this.model.areaCode = response.data.stockArea !== null ? response.data.stockArea.areaCode : '-'
        this.model.stockAddress = response.data.stockArea !== null ? response.data.stockArea.areaAddress : '-'
        this.model.journalAccount = response.data.journalAccount !== null ? response.data.journalAccount.journalAccountName : '-'
        this.model.selectedJournalAccount = response.data.journalAccount !== null ? response.data.journalAccount.journalAccountName : '-'
        let createdName = response.data.createdBy.firstName + ' ' + response.data.createdBy.lastName
        let updatedName = response.data.createdBy.firstName + ' ' + response.data.createdBy.lastName
        this.model.createdBy = {
          firstName: createdName
        }
        this.model.changedBy = {
          firstName: updatedName
        }
        this.model.createdAt = response.data.createdAt !== null
              ? this.$moment(response.data.createdAt  ).format('DD MMMM YYYY')
              : null;

        this.model.createdAt = response.data.createdAt !== null
              ? this.$moment(response.data.createdAt  ).format('DD MMMM YYYY')
              : null;

        this.model.updatedAt = response.data.updatedAt !== null
              ? this.$moment(response.data.updatedAt  ).format('DD MMMM YYYY')
              : null;

        if(response.data.stockInItem){
          this.model.items
          this.model.items = response.data.stockInItem
        }
        setTimeout(()=>{
          this.isLoading = false
        }, 1500)
      }).catch(error=>{
        this.$store.dispatch("notification/error", error)
      })
    }
  }
}
</script>

<style scoped>
.break-text{
  white-space: pre-line !important;
}
</style>